
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class GTripleWattMinModal extends Vue {

    @Prop({
        default: () => new OM.GTripleWattMinModel()
    }) model: OM.GTripleWattMinModel;

    localModel: OM.GTripleWattMinModel = new OM.GTripleWattMinModel();

    @Prop() callback: any;

    created() {
        this.localModel = this.model;
    }

    get canSave(){
        return this.localModel.grams.key && this.localModel.watt.key && this.localModel.watt2.key
            && this.localModel.watt3.key && this.localModel.minutes.key;
    }

    save() {
        if(!this.canSave)
            return;

        this.callback(this.localModel);
    }
    
}
